<template>
  <div style="margin-top: 5px" id="target" v-if="isValidUser">
    <div class="form-row">
      <h3>User Credits</h3>
    </div>
    <div class="form-row">
      <div style="width: 30%" class="form-row-input">
        <ejs-button type="button" cssClass="e-danger" v-on:click.native="onAddApplicantClick">
          <font-awesome-icon :icon="['fas', 'plus-square']" style="display: inline" />
          ADD APPLICANT
        </ejs-button>
      </div>
    </div>
    <ejs-grid
      :dataSource="accountingUserCredits"
      ref="refAccountingUserCreditsGrid"
      :created="created"
      :allowSorting="true"
      :allowPaging="true"
      :pageSettings="pageSettings"
      :toolbar="toolbarOptions"
      :toolbarClick="toolbarClick"
      :commandClick="editInvoice"
      :allowTextWrap="true"
      :textWrapSettings="wrapSettings"
      :allowExcelExport="true"
    >
      <e-columns>
         <e-column headerText="Edit" :commands="commands" textAlign="center" width="85" />
        <e-column field="userFullName" headerText="Applicant Name" textAlign="left" width="200" />
        <e-column field="companyName" headerText="Applicant Company" width="240" />
        <e-column field="email" headerText="Email" textAlign="Left" width="160" />
        <e-column field="creditActive" headerText="Status" textAlign="Left" width="160" format="C2" />
        <e-column
          field="creditTotalAmount"
          headerText="Credit Limit"
          textAlign="Left"
          width="160"
          format="C2"
        />
        <e-column
          field="creditUsed"
          headerText="Credit Used"
          textAlign="Left"
          width="160"
          format="C2"
        />
        <e-column
          field="creditRemaining"
          headerText="Credit Remaining"
          textAlign="Left"
          width="160"
          format="C2"
        />
      </e-columns>
    </ejs-grid>
  </div>
</template>

<script>
import Vue from "vue";
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
  ExcelExport,
} from "@syncfusion/ej2-vue-grids";
import { mapGetters } from "vuex";
import { reportExportFileName } from '@/utils/report-utils';
import { SET_PREVIOUS_ACCOUNTING_TAB } from "../store";

Vue.use(GridPlugin);

export default {
  name: "AccountingUserCredits",
  props: {
    isValidUser: Boolean,
  },
  data() {
    return {
      commands: [
        {
          type: "Edit Credit",
          buttonOption: {
            cssClass: "e-flat viewpdfbtn",
            iconCss: "e-edit e-icons",
          },
        },
      ],
      toolbarOptions: ["Search", "ExcelExport"],
      pageSettings: { pageSize: 10 },
      target: "#target",
      wrapSettings: { wrapMode: "both" },
    };
  },
  computed: {
    ...mapGetters({
      // accountingUserCredits: "accountingUserCredits",
      loggedUser: "loggedUser",
    }),
    accountingUserCredits(){
      return  this.$store.getters.accountingUserCredits?.map(x => {
        x.creditActive = x.creditActive ? 'Active' : 'Inactive';
        return x;
      });
    },
    loggedUserId() {
      return this.loggedUser?.id;
    },
    isAdmin() {
      const roles = this.loggedUser.roles?.map((x) => x.roleName);
      const isAdmin = roles.includes("Admin") || roles.toLowerCase().includes("SuperAdmin");
      return isAdmin;
    },
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar

      if (this.$refs.refAccountingUserCreditsGrid) {
        const refAccountingUserCreditsGridSearchEle = document.getElementById(
          `${this.$refs.refAccountingUserCreditsGrid.$el.id}_searchbar`,
        );
        if (refAccountingUserCreditsGridSearchEle) {
          refAccountingUserCreditsGridSearchEle.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.refAccountingUserCreditsGrid.$el.id);
          });
        }
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove("e-search-icon");
      clearBtnEle.classList.add("e-clear-icon");

      clearBtnEle.addEventListener("click", () => {
        e.target.value = "";
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount == 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value == "") {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    async editInvoice(args) {
      const userCredit = args.rowData;
      const { userId } = userCredit;
      if (this.isAdmin) {
        this.$store.commit(SET_PREVIOUS_ACCOUNTING_TAB, { previousTab: 2 });
        this.$router.push(`/accounting/editusercredit/${userId}`);
      }
    },

    onAddApplicantClick() {
      this.$store.commit(SET_PREVIOUS_ACCOUNTING_TAB, { previousTab: 2 });
      this.$router.push("/accounting/newusercredit");
    },

    toolbarClick(args) {
      switch (args.item.text) {
        case "Excel Export":
          this.$refs.refAccountingUserCreditsGrid.excelExport({
            fileName: reportExportFileName('Credits.xlsx'),
          });
          break;
      }
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search, ExcelExport],
  },
};
</script>
